import { useModalHandlerContext } from "../contexts/modal-handler-context";
import { useCodeContext } from "../contexts/code-context";

export default function useModalContext<T = any>(code?:string){
    const innerCode = useCodeContext();
    const { isModalOpen, getModalValue, closeModal, isModalCloseable, setModalCloseable } = useModalHandlerContext();
    
    const codeToUse = code?code:innerCode;

    return {
        code:codeToUse,
        value:getModalValue(codeToUse) as T,
        open:isModalOpen(codeToUse),
        closeable:isModalCloseable(codeToUse),
        handleClose:()=>closeModal(codeToUse),
        setCloseable:(value:boolean)=>setModalCloseable(codeToUse, value)
    };
}

export type useModalContextReturn<T = any> = ReturnType<typeof useModalContext<T>>